import { RigRateTypeBase } from './base/rig-rate-type-base';

export class RigRateType extends RigRateTypeBase { }